/** Cache names shared by the service worker config and the app. */
export const API_CACHE = 'pv-api';
export const IMAGE_CACHE = 'pv-images';

/**
 * Drops cached API data, e.g. on logout, so the next person on this device
 * does not see the collection offline. Covers stay: they carry no data.
 */
export async function clearApiCache(): Promise<void> {
  try {
    if ('caches' in window) await caches.delete(API_CACHE);
  } catch {
    // No cache storage (private mode, old browser): nothing to clear.
  }
}
